import React, { useState, useEffect } from "react";
import styles from "./Modify.module.scss";
import { SelectField } from "../../components/Form/SelectField";
import {
  cradleUpdate,
  fetchPremiumList,
} from "../../redux/admin/actions/admin.actions";
import { Formik, Form } from "formik";
import Styles from "./Modify.module.scss";
import { useDispatch, useSelector } from "react-redux";

const ModifyForm = ({ selectedItem, setIsModalOpen, setModifyModal }) => {
  const [prem, setPrem] = useState();
  const dispatch = useDispatch();
  const [selectedPremium, setSelectedPremium] = useState();
  const { premiumList } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    dispatch(fetchPremiumList());
    const option = premiumList.map((p) => ({
      label: p.name,
      value: p.id,
    }));
    setPrem(option);
  }, [dispatch]);
  // const handleSubmit = () => {};

  const handleClose = () => {
    setModifyModal(false);
    setIsModalOpen(false);
  };
  return (
    <div>
      <Formik
        initialValues={{
          oxygen: selectedItem.oxygen,
          blood: selectedItem.blood,
        }}
        onSubmit={(values) => {
          // console.log("ddd", values);
          // console.log("love", values.oxygen);
          dispatch(
            cradleUpdate({
              id: selectedItem.id,
              oxygen: values.oxygen || selectedItem.oxygen,
              blood: values.blood || selectedItem.blood,
            })
          );
          setModifyModal(false);
        }}
      >
        {({ handleSubmit }) => (
          <Form>
            <div className="d-flex flex-column mb-3">
              <p className={Styles.label}>Oxygen</p>
              <div className="w-100 mt-2">
                <SelectField
                  name="oxygen"
                  placeholder={selectedItem.blood}
                  // as="select"
                  className={`${Styles.formInput} shadow-none form-control`}
                  onBlur={() => {}}
                  options={prem}
                  onChange={(e) => setSelectedPremium(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="d-flex flex-column mb-3">
              <p className={Styles.label}>Blood</p>
              <div className="w-100 mt-2">
                <SelectField
                  placeholder={selectedItem.oxygen}
                  name="blood"
                  // as="select"
                  options={prem}
                  className={`${Styles.formInput} shadow-none form-control`}
                  onBlur={() => {}}
                  onChange={(e) => setSelectedPremium(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className={`shadow-none ${Styles.actionBtn} ${Styles.confirm}`}
                // style={{ background: props.btnColor }}
                onClick={handleClose}
              >
                Cancel
              </button>

              <button
                type="submit"
                className={`shadow-none ${Styles.actionBtn} ${Styles.reject}`}
                // style={{ background: props.btnColor }}
                onClick={handleSubmit}
              >
                Update
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ModifyForm;
